import { action, payload } from 'ts-action';

import { Tokens } from './types';

export const KEYCLOAK = '[KEYCLOAK]';
export const KEYCLOAK_STATE = `${KEYCLOAK} KEYCLOAK_STATE`;

export const keycloakMessage = action(KEYCLOAK_STATE, payload<{ event?: string | unknown; tokens?: Tokens }>());
